export enum ConnectionStatus {
  Pending = 'pending',
  Accepted = 'accepted',
  Declined = 'declined',
}

export const CONNECTION_STATUS_I18N: Record<ConnectionStatus, string> = {
  [ConnectionStatus.Accepted]: 'Akzeptiert',
  [ConnectionStatus.Declined]: 'Abgelehnt',
  [ConnectionStatus.Pending]: 'Ausstehend',
};
